import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import { TermAndConditionModel } from './model';

export function useGetTermAndCondition(
  options?: UseQueryOptions<ApiResult<TermAndConditionModel>, ApiError>,
): UseQueryResult<ApiResult<TermAndConditionModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getTermAndCondition'],
      () => QueryFetchFunction({ url: 'terms-and-conditions' }),
      { staleTime: Infinity, cacheTime: Infinity, ...options },
    ),
    TermAndConditionModel,
  );
}
export function getTermAdnCondition() {
  return ['getTermAndCondition'];
}
